
import * as types from 'action/actionTypes';
import * as url from 'api/url';
import APIutil from 'api/APIutils';
import { global_error_handling } from 'action/GlobalErrorMgmtAction';

function wait(ms, numAttempted){
    var start = new Date().getTime();
    var end = start;
    while(end < start + ms) {
        end = new Date().getTime();
    }
    return numAttempted + 1;
}

export function getArtifactFilename(report_ID, numExisting, report_Name, numAttempts, maxAllowedAttempts) {   
    return function (dispatch) {
        return APIutil.getPDFDataAPI(url.get_reportsHistoryList + "generatedArtifact/" + report_ID + "/" + numExisting).then(response => {
            dispatch(global_error_handling(response));

            if(!response.status && response.size > 0) {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([response]), report_Name);
                }
                else 
                {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', report_Name);
                    document.body.appendChild(link);
                    link.click();
                }

                document.getElementById('loadingArea').style.display = 'none';
                dispatch(actionToStoreSuccess('', types.RUN_REPORT_FILE_LINK)); // clear out selections
                dispatch(actionToStoreSuccess(null, types.RUN_REPORT_FILE_LINK)); // stop process
            } else if (response.status === 400 || response.status === 404 || response.status === 401){
                dispatch(actionToStoreSuccess(null, types.RUN_REPORT_FILE_LINK));
                document.getElementById('loadingArea').style.display = 'none'; 
                document.getElementById('noFileGen').style.display = 'block'; // 404 is name was not able to be generated; 401 is bad user
            } else if (response.status === 504 || response.status === 304 || response.status === 502) {
                // try again
                if (numAttempts < maxAllowedAttempts) {
                    numAttempts = wait(2000, numAttempts);
                    dispatch(getArtifactFilename(report_ID, numExisting, report_Name, numAttempts, maxAllowedAttempts));
                } else {
                    dispatch(actionToStoreSuccess(numAttempts, types.RUN_REPORT_FILE_LINK)); 
                    dispatch(actionToStoreSuccess(null, types.RUN_REPORT_FILE_LINK)); // stop process */
                }
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function getArtifactTemplate(reportID, reportName) {
  return function (dispatch) {
    return APIutil.getTemplateDataAPI(url.get_reportsTemplates + reportID)
      .then((response) => {
        dispatch(global_error_handling(response));

        var fileName = reportName,
          fileFormat = ".rdl";
        var loadingfield = document.getElementById("loadingArea");

        if (response.status === 200) {
          loadingfield.style.display = "block";
          document.getElementById("longRunningProcess").style.display = "none"; //hide long running process message
          document.getElementById("noFileGen").style.display = "none"; // hide no file generation message
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([response]),
              fileName
            );
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", reportName + fileFormat);
            document.body.appendChild(link);
            link.click();
            loadingfield.style.display = "none";
          }
        }
      })
      .catch((error) => {
        throw error;
      });
  };
}


export function DeleteArtifacts(reportId, deletedArtifacts) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.delete_artifacts + reportId, deletedArtifacts).then(response => {
        dispatch(global_error_handling(response));
           
        if(response.status === 200)
               dispatch(getReportsSubList(reportId));
        }).catch(error => {
            throw error;
        })
    }
}

export function DeleteReports(deletedReports) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.get_reportsList, deletedReports).then(response => {
        dispatch(global_error_handling(response));    
        if(response.status === 200)
               dispatch(getReportsList());
        }).catch(error => {
            throw error;
        })
    }
}

export function DownloadSelectedReport(artifactFileName, downloadName) { 
    return function (dispatch) {
        return APIutil.getPDFDataAPI(url.get_generated_report + "/" + artifactFileName).then(response => {
            dispatch(global_error_handling(response)); 
            dispatch(actionToStoreSuccess(null, types.RUN_REPORT_FILE_LINK)); // set this so the call to get the file stops
            var errorField = document.getElementById('noFile');

            if (!response.status) {
                if (errorField)
                    errorField.style.display = 'none';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    console.log("IE Browser");
                    window.navigator.msSaveOrOpenBlob(new Blob([response]), downloadName);
                }
                else 
                {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', downloadName);
                    document.body.appendChild(link);
                    link.click();
                }
            } else if (response.status === 404 ) { 
                if (errorField)
                    errorField.style.display = 'block';
            } 
        }).catch(error => { throw error; })
    }
}

export function EmailSelectedArtifacts(reportId, artifactEmailInfo) { 
    return function (dispatch) {
        return APIutil.postData("/api/reportmanagement/artifacts/mail/" + reportId, artifactEmailInfo).then(response => {
            dispatch(global_error_handling(response));
            var errorField = document.getElementById('noEmail');
            var successField = document.getElementById('emailSuccess');
    
            if (errorField)
                errorField.style.display = response && response.status === 200 ? 'none' : 'initial';
    
            if (successField)
                successField.style.display = response && response.status === 200 ? 'initial' : 'none';
    
        }).catch(error => { throw error; })
    }
}

export function getAllBuildingsList(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_All_Buildings).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response,types.GET_ALL_BUILDINGS_LIST));
        }).catch(error => {throw error;})
    }
}

export function getAllFamilyTypesList() {                                                                          // Fetching Reports List 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_All_Family_Types).then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_ALL_FAMILY_TYPES_LIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function getEquipmentList(selectedSitesFamilyTypes) {                                                                  // Fetching Reports Sub List 
    return function (dispatch) {
        return APIutil.postData(url.get_Buildings_FamilyTypes_Equipment, selectedSitesFamilyTypes).then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response.data, types.GET_BUILDINGS_FAMILY_TYPES_EQUIPMENT));
        }).catch(error => {
            throw error;
        })
    }
}

export function getEquipmentPropertiesList(selectedEquipment,startDate,endDate) {                                                                  // Fetching Reports Sub List 
    return function (dispatch) {
                // temp for testing
                var equipRequest = {
                    "ControllerIds":  selectedEquipment,
                    "StartDate": startDate,
                    "EndDate": endDate
             }
        return APIutil.postData(url.get_Equipment_Properties, equipRequest).then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response.data, types.GET_EQUIPMENT_PROPERTIES_LIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function getDatalogDefinitionsList(selectedDatalogDefinitions) {                                                                  // Fetching Reports Sub List 
    return function (dispatch) {
        return APIutil.postData(url.get_DatalogDefinitions, selectedDatalogDefinitions).then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response.data, types.GET_DATALOG_DEFINITIONS_LIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function saveExportWithoutSchedule(data){
    return function(dispatch){
        return APIutil.postData(url.post_Export_Without_Schedule,data).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined && response.data.saved === true)
                dispatch(getReportsList());
        }).catch(error => {
            throw error;
        })
    }
}

export function updateExportWithoutSchedule(data){
    return function(dispatch){
        // return APIutil.editDataAPI(url.put_Export_Without_Schedule + data.ReportId ,data).then(response => {
        //     dispatch(global_error_handling(response));
        //     if(response !== null && response !== undefined && response.data.saved === true)
        //         dispatch(getReportsList());
        // }).catch(error => {
        //     throw error;
        // })

        return APIutil.editDataAPI(url.put_Export_Without_Schedule+ data.ReportId ,data).then(response =>{
            dispatch(global_error_handling(response));
        }).catch(error => { throw error; })
    }
}

 // Fetching Reports List 
export function getReportsList() {                                                                         
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_reportsList).then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_MANAGEREPORTS_LIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function getReportsSubList(report_id) {                                                                  // Fetching Reports Sub List 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_reportsHistoryList + report_id + "/artifacts").then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_MANAGEREPORTS_SUB_LIST));
        }).catch(error => {
            throw error;
        })
    }
}

export function runReports(report_ID, fileFormat) {                                                            // Run and Generate reports in PDF or excel formats
    return function (dispatch) {
        return APIutil.postDataForPDF(url.get_reportsHistoryList + report_ID + "/artifact", fileFormat).then(response => {
            dispatch(global_error_handling(response));
            var loadingfield = document.getElementById('loadingArea');

            if (response.status === 200) {
                loadingfield.style.display = 'block';
                document.getElementById('longRunningProcess').style.display = 'none'; //hide long running process message 
                document.getElementById('noFileGen').style.display = 'none'; // hide no file generation message
                dispatch(actionToStoreSuccess(fileFormat, types.RUN_REPORT_FILE_LINK));
            }
        }).catch(error => { throw error; })
    }
}

export function UpdateReportDefinition(reportId, reportName) { 
    return function (dispatch) {
       return APIutil.postData(url.get_reportsHistoryList + reportId + "/reportName/" + reportName).then(response => {
            dispatch(global_error_handling(response)); 

            if(response.status === 200) {
                dispatch(getReportsList());

            }
        }).catch(error => {
            throw error;
        })
    }
}

export function getDataSourceDetails(reportId){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Export_DataSource + reportId + "/DataSource").then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_DATASOURCE_DETAILS));
        }).catch(error => {throw error;})
    }
}

/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking its type and updates the state. */
export function actionToStoreSuccess(response, actionType) {
    return {
        type: actionType,
        getResponse: response,
    }
}



